import { render, staticRenderFns } from "./layout-widget-form.vue?vue&type=template&id=6bc729e8"
import script from "./layout-widget-form.vue?vue&type=script&lang=ts"
export * from "./layout-widget-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports